<template>
  <div>
    <b-card title="Performance Report">
      <!-- search input -->
      <validation-observer ref="searchForm" #default="{ invalid }">
        <b-form @submit.stop.prevent @submit="onSubmit">
          <b-row>
            <b-col>
              <b-form-group label="Merchants option" label-for="Merchants">
                <validation-provider
                  v-slot="{ errors, validated, invalid }"
                  name="merchants"
                  rules="required"
                >
                  <v-select
                    multiple
                    v-model="selected"
                    :options="merchants"
                    label="name"
                    :class="{
                      'is-invalid': invalid,
                      'is-valid': validated && !invalid,
                    }"
                  >
                    <template #option="option">
                      <span>{{ option.name }}</span>
                    </template>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Period" label-for="Period">
                <b-form-select
                  v-model="selectedPeriod"
                  :options="periodOptions"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group v-if="selectedPeriod == 1">
                Date 1
                <flat-pickr
                  v-model="trxnStartDate"
                  class="form-control"
                  :config="flatpickrConfig"
                  :key="selectedPeriod"
                />

                Date 2
                <flat-pickr
                  v-model="trxnEndDate"
                  class="form-control"
                  :config="flatpickrConfig"
                  :key="selectedPeriod"
                />
              </b-form-group>

              <b-form-group v-else-if="selectedPeriod == 2">
                Month 1
                <flat-pickr
                  v-model="trxnStartDate"
                  class="form-control"
                  :config="flatpickrConfig"
                  :key="selectedPeriod"
                />

                Month 2
                <flat-pickr
                  v-model="trxnEndDate"
                  class="form-control"
                  :config="flatpickrConfig"
                  :key="selectedPeriod"
                />
              </b-form-group>

              <b-form-group v-else-if="selectedPeriod == 3">
                Year 1
                <v-select v-model="trxnStartDate" :options="years" label="name">
                  <template #option="option">
                    <span>{{ option.name }}</span>
                  </template>
                </v-select>

                Year 2
                <v-select v-model="trxnEndDate" :options="years" label="name">
                  <template #option="option">
                    <span>{{ option.name }}</span>
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="d-flex justify-content-end">
            <b-button
              v-if="trxnEndDate && trxnStartDate"
              type="submit"
              variant="primary"
            >
              Submit
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </b-card>
    <b-row class="mb-1">
      <b-col class="d-flex flex-row">
        <section v-if="dataFiltered === true">
          <xlsx-workbook>
            <xlsx-sheet
              v-for="sheet in sheets"
              :key="sheet.name"
              :collection="sheet.data"
              :sheet-name="sheet.name"
            />
            <xlsx-download>
              <b-button variant="primary" class="d-flex">
                <feather-icon icon="DownloadCloudIcon" /> Export
              </b-button>
            </xlsx-download>
          </xlsx-workbook>
        </section>
      </b-col>
    </b-row>
    <b-card title="Payment Transactions Report">
      <b-row>
        <b-col>
          <b-table
            :items="performanceReportForOrder"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            :responsive="true"
            outlined
            hover
          >
            <!-- <template v-slot:reconciliations(paymentOptionLogoPath)="data">
                <b-avatar :src="data.item.paymentOptionLogoPath" />
              </template> -->
            <template v-slot:cell(dateRange)>
              <span>{{ trxnDateRange }}</span>
            </template>
          </b-table>
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to &nbsp; </span>
              <b-form-select
                id="per-page-select"
                v-model="perPage"
                :options="[5, 10, 15, 20, { value: 100, text: 'Show all' }]"
                size="sm"
              ></b-form-select>
              <span class="text-nowrap">
                &nbsp; of {{ performanceReportForOrder.length }} entries
              </span>
            </div>
            <div>
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
              />
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-card title="Refund Transactions Report">
      <b-row>
        <b-col>
          <b-table
            :items="performanceReportForRefund"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            :responsive="true"
            outlined
            hover
          >
            <!-- <template v-slot:reconciliations(paymentOptionLogoPath)="data">
                <b-avatar :src="data.item.paymentOptionLogoPath" />
              </template> -->
            <template v-slot:cell(dateRange)>
              <span>{{ trxnDateRange }}</span>
            </template>
          </b-table>
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to &nbsp; </span>
              <b-form-select
                id="per-page-select"
                v-model="perPage"
                :options="[5, 10, 15, 20, { value: 100, text: 'Show all' }]"
                size="sm"
              ></b-form-select>
              <span class="text-nowrap">
                &nbsp; of {{ performanceReportForRefund.length }} entries
              </span>
            </div>
            <div>
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
              />
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-overlay :show="isLoading" no-wrap rounded="sm" />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BForm,
  BFormGroup,
  BDropdown,
  BFormSelect,
  BButton,
  BTable,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "@validations";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import XlsxSheet from "../../../../node_modules/vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "../../../../node_modules/vue-xlsx/dist/components/XlsxDownload";
import XlsxWorkbook from "../../../../node_modules/vue-xlsx/dist/components/XlsxWorkbook";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BForm,
    BFormGroup,
    BDropdown,
    BFormSelect,
    BButton,
    BTable,
    BPagination,
    BOverlay,
    vSelect,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data() {
    const currentYear = new Date().getFullYear();
    const startYear = 2019;
    return {
      years: Array.from(
        { length: currentYear - startYear },
        (_, i) => currentYear - i
      ),
      required,
      isLoading: false,
      dataFiltered: false,
      currentPage: 1,
      perPage: 10,
      merchants: [],
      selected: [],
      merchantIds: "",
      trxnStartDate: "",
      trxnEndDate: "",
      periodOptions: [
        { value: 1, text: "Daily" },
        { value: 2, text: "Monthly" },
        { value: 3, text: "Yearly" },
      ],
      selectedPeriod: 0,
      performanceReportForRefund: [],
      performanceReportForOrder: [],
      fields: [
        { key: "currency", label: "Currency" },
        {
          key: "totalOnFirstDate",
          label: "Count Current Transactions ",
        },
        {
          key: "sumOnFirstDate",
          label: "Total Current Transaction Amounts",
        },
        {
          key: "averageOnFirstDate",
          label: "Current Average Transaction Value",
        },
        {
          key: "costSavingOnFirstDate",
          label: "Current Cost Saving",
        },
        {
          key: "totalOnSecondDate",
          label: "Count Last Transactions",
        },
        {
          key: "sumOnSecondDate",
          label: "Total Last Transaction Amounts",
        },
        {
          key: "averageOnSecondDate",
          label: "Last Average Transaction Value",
        },
        {
          key: "costSavingOnSecondDate",
          label: "Last Cost Saving",
        },
        {
          key: "growthrate",
          label: "Growth Rate",
        },
      ],
      sheets: [
        { name: "Payment-Report", data: [] },
        { name: "Refund-Report", data: [] },
      ],
    };
  },
  computed: {
    rows() {
      return this.performanceReportForRefund.length;
      return this.performanceReportForOrder.length;
    },

    flatpickrConfig() {
      if (this.selectedPeriod === 1) {
        return { maxDate: "today" };
      } else if (this.selectedPeriod === 2) {
        return {
          plugins: [
            monthSelectPlugin({
              shorthand: true,
              dateFormat: "Y-m",
            }),
          ],
        };
      }
    },
  },
  watch: {
    selectedPeriod() {
      this.trxnStartDate = "";
      this.trxnEndDate = "";
    },
  },
  created() {
    this.fetchMerchant();
  },
  beforeCreate() {},
  methods: {
    fetchMerchant() {
      this.isLoading = true;
      axios
        .get("/Merchant/api/V1.0/Merchants/GetMerchants")
        .then((res) => {
          this.merchants = res.merchants;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    onSubmit() {
      this.$refs.searchForm.validate().then(async (success) => {
        if (success) {
          this.isLoading = true;
          await this.selected.map((m) => {
            this.merchantIds += m.id + ",";
          });
          this.merchantIds = this.merchantIds.slice(0, -1);
          await this.GetKPIPerformanceReportForOrder();
          await this.GetKPIPerformanceReportForRefund();
        }
      });
    },
    GetKPIPerformanceReportForOrder() {
      this.$store.dispatch(
        "config/getActionPrivilege",
        "Report-PerformanceReport"
      );
      let api = null;
      if (this.selectedPeriod == 1) {
        api = `/Order/api/V1.0/Report/GetKPIPerformanceReportForOrder?firstPerid=${this.trxnStartDate}&secondPerid=${this.trxnEndDate}&reportType=1&merchantIds=${this.merchantIds}`;
      } else if (this.selectedPeriod == 2) {
        api = `/Order/api/V1.0/Report/GetKPIPerformanceReportForOrder?firstPerid=${this.trxnStartDate}&secondPerid=${this.trxnEndDate}&reportType=2&merchantIds=${this.merchantIds}`;
      } else if (this.selectedPeriod == 3) {
        api = `/Order/api/V1.0/Report/GetKPIPerformanceReportForOrder?firstPerid=${this.trxnStartDate}&secondPerid=${this.trxnEndDate}&reportType=3&merchantIds=${this.merchantIds}`;
      }

      axios
        .get(api)
        .then((res) => {
          this.sheets[0].data = [];
          this.performanceReportForOrder = res.reportGroupedByCurrency;
          res.reportGroupedByCurrency.map((m) => {
            this.sheets[0].data.push({
              currency: m.currency,
              "Count Current Transactions ": m.totalOnFirstDate,
              "Total Current Transaction Amounts": m.sumOnFirstDate,
              "Current Average Transaction Value": m.averageOnFirstDate,
              "Current Cost Saving": m.costSavingOnFirstDate,
              "Count Last Transactions": m.totalOnSecondDate,
              "Total Last Transaction Amounts": m.sumOnSecondDate,
              "Last Average Transaction Value": m.averageOnSecondDate,
              "Last Cost Saving": m.costSavingOnSecondDate,
              "Growth Rate": m.growthrate,
            });
          });
          this.dataFiltered = true;
          this.isLoading = false;
          this.merchantIds = "";
        })
        .catch((res) => {
          console.log(res);
          this.merchantIds = "";
        });
    },
    GetKPIPerformanceReportForRefund() {
      this.$store.dispatch(
        "config/getActionPrivilege",
        "Report-PerformanceReport"
      );

      let api = null;
      if (this.selectedPeriod == 1) {
        api = `/Order/api/V1.0/Report/GetKPIPerformanceReportForRefund?firstPerid=${this.trxnStartDate}&secondPerid=${this.trxnEndDate}&reportType=1&merchantIds=${this.merchantIds}`;
      } else if (this.selectedPeriod == 2) {
        api = `/Order/api/V1.0/Report/GetKPIPerformanceReportForRefund?firstPerid=${this.trxnStartDate}&secondPerid=${this.trxnEndDate}&reportType=2&merchantIds=${this.merchantIds}`;
      } else if (this.selectedPeriod == 3) {
        api = `/Order/api/V1.0/Report/GetKPIPerformanceReportForRefund?firstPerid=${this.trxnStartDate}&secondPerid=${this.trxnEndDate}&reportType=3&merchantIds=${this.merchantIds}`;
      }

      axios
        .get(api)
        .then((res) => {
          this.sheets[1].data = [];
          this.performanceReportForRefund = res.reportGroupedByCurrency;
          res.reportGroupedByCurrency.map((m) => {
            this.sheets[1].data.push({
              currency: m.currency,
              "Count Current Transactions ": m.totalOnFirstDate,
              "Total Current Transaction Amounts": m.sumOnFirstDate,
              "Current Average Transaction Value": m.averageOnFirstDate,
              "Current Cost Saving": m.costSavingOnFirstDate,
              "Count Last Transactions": m.totalOnSecondDate,
              "Total Last Transaction Amounts": m.sumOnSecondDate,
              "Last Average Transaction Value": m.averageOnSecondDate,
              "Last Cost Saving": m.costSavingOnSecondDate,
              "Growth Rate": m.growthrate,
            });
          });
          this.dataFiltered = true;
          this.isLoading = false;
          this.merchantIds = "";
        })
        .catch((res) => {
          console.log(res);
          this.merchantIds = "";
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style lang="css">
.is-invalid {
  border: 1px solid #dc3545; /* Red border for invalid input */
  border-radius: 4px;
}

.is-valid {
  border: 1px solid #28a745; /* Green border for valid input */
  border-radius: 4px;
}
</style>
